module.exports = __webpack_public_path__ + "img/video-zcpd.4af672d3.jpg";